import React from 'react';

import ChipOnTable from "../../chip/chip-on-table";

import {uuid} from "../../../helpers/uuid";
import {BetTypeTableLeftColumns} from "../../../enums/tableNumbers";

export const RectangleTableRight = ({allChipsTypes, handleGetColumnChip}) => {
  return (
    <div className="table-content-right">
      {
        Object.keys(BetTypeTableLeftColumns).map(column => {
          const columnChip = handleGetColumnChip(column)
          return (
            <div key={uuid()} className={`main-game-cont-box `} data={column}>
              <ChipOnTable
                type={column}
                columnChips={columnChip}
                child={() => <p className='main-game-box-text' data={column}>2:1</p> }
                allChipsTypes={allChipsTypes}
              />
            </div>
          )
        })
      }
    </div>
  )
};
